import { Alert, List, Popover, Radio, Text } from '@ksyos/design-system';
import type { IOsasReferralData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralSchema';
import type { ValidationErrors } from '@frontend/utils';
import { SleepRecorderType } from '@common/validation/customControls/osas/sleepRecorderType';
import { getSelectedLanguage } from '@frontend/translate';
import { RadioGroupFormGroup } from '../../../processActivityFormGroupFields';

interface ISleepRecorderTypeFormGroupProps {
    canReferPatientWithoutSmartphone: boolean;
    data: IOsasReferralData;
    errors: ValidationErrors;
    onChange: (data: Partial<IOsasReferralData>, validateKeys?: string | string[] | undefined) => void;
}

export function SleepRecorderTypeFormGroup(props: ISleepRecorderTypeFormGroupProps) {
    const { canReferPatientWithoutSmartphone, data, errors, onChange } = props;
    const translate = getSelectedLanguage();
    const recorderInfo = (
        <List
            size="small"
            styleType="bullet"
        >
            <List.Item>De patiënt ontvangt de recorder thuis met een handleiding om een app te downloaden</List.Item>
            <List.Item>
                Met behulp van instructievideo’s in de app kan de patiënt binnen enkele minuten de slaaprecorder
                instellen en gebruiken
            </List.Item>
            <List.Item>
                Bij vragen of onduidelijkheden kan de patiënt contact opnemen met ons en begeleiden wij de patiënt
                verder
            </List.Item>
        </List>
    );

    return (
        <>
            <Text
                mb={3}
                size="sm"
            >
                Lees meer over het{' '}
                <Popover content={recorderInfo}>gebruik van de smartphone met de slaaprecorder</Popover>
            </Text>

            <RadioGroupFormGroup
                error={errors.get('sleepRecorderType')}
                fieldKey="sleepRecorderType"
                isRequired={true}
                label="Patiënt beschikt over een smartphone"
                onChange={async (value) => {
                    onChange(
                        {
                            sleepRecorderType: value as SleepRecorderType,
                        },
                        'sleepRecorderType'
                    );
                }}
                radioGroupLayout="row"
                tooltipText="Heeft de patiënt geen smartphone of tablet, wil of kan de patiënt geen app installeren of gebruiken, of is de patiënt niet technisch onderlegd? Kies dan Nee."
            >
                <Radio
                    key={SleepRecorderType.recorderWithSmartphone}
                    label={translate.common.yes}
                    value={SleepRecorderType.recorderWithSmartphone}
                />
                <Radio
                    key={SleepRecorderType.recorderWithoutSmartphone}
                    label={translate.common.no}
                    value={SleepRecorderType.recorderWithoutSmartphone}
                />
            </RadioGroupFormGroup>
            {!canReferPatientWithoutSmartphone &&
                data.sleepRecorderType === SleepRecorderType.recorderWithoutSmartphone && (
                    <Alert appearance="warning">
                        Voor het gebruik van de slaaprecorder heeft de patiënt een smartphone of tablet nodig. Ksyos
                        stuurt de slaaprecorder naar de patiënt
                    </Alert>
                )}
        </>
    );
}
